import React from 'react'
import Container from 'components/container.js'
import BackToTop from 'components/back-to-top'

export default function ListingLayout({ children, customPadding, n, ...props }) {
    return <Container {...props} fluid>
        <Container>
            <div css={{
                padding: customPadding ? customPadding : '48px 32px 80px',
                '@media(max-width: 768px)': {
                    paddingLeft: 16,
                    paddingRight: 16,
                }
            }}>
                {children}
                <p className='text-center sm' style={{ marginTop: 64 }}>
                    You've seen {n} of {n} Products.
                </p>
                <BackToTop style={{ marginTop: 64 }} />
            </div>
        </Container>
    </Container>
}
